import { required } from "../../../../../../../shared/utils/forms/utils/validationType";

export const useValidationOxygen = (t: any, dataForm: any) => {
  const validations = [
    {
      name: "pathology",
      validations: [
        {
          name: required,
          params: {
            name: t("common.pathologies")
          }
        }
      ]
    },
    {
      name: "flowRest",
      validations: [
        {
          name: required,
          params: {
            name: t("prescription.template.flowRest")
          }
        }
      ]
    },
    {
      name: "flowRestHourDie",
      validations: [
        {
          name: required,
          params: {
            name: t("prescription.template.hourDie")
          }
        }
      ]
    },
    {
      name: "underStressFlow",
      validations: [
        {
          name: required,
          params: {
            name: t("prescription.template.underStressFlow")
          }
        }
      ]
    },
    {
      name: "underStressFlowHourDie",
      validations: [
        {
          name: required,
          params: {
            name: t("prescription.template.hourDie")
          }
        }
      ]
    },
    {
      name: "nightFlow",
      validations: [
        {
          name: required,
          params: {
            name: t("prescription.template.nightFlow")
          }
        }
      ]
    },
    {
      name: "nightFlowHourDie",
      validations: [
        {
          name: required,
          params: {
            name: t("prescription.template.hourDie")
          }
        }
      ]
    }
  ];

  return validations;

};
